import { Component, Input, OnDestroy } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-environment-endpoints',
  templateUrl: './environment-endpoints.component.html',
  styleUrls: ['./environment-endpoints.component.scss'],
  standalone: false
})
export class EnvironmentEndpointsComponent implements OnDestroy {
  @Input() endpoints: any[] = [];
  @Input() isLoading = false;

  copiedUrl: string | null = null;
  readonly skeletonRows = [1, 2, 3, 4];

  private readonly COPIED_RESET_MS = 5000; 
  private copyTimer?: ReturnType<typeof setTimeout>;

  constructor(private clipboardApi: ClipboardService) {}

  onCopyId(url: string): void {
    this.clipboardApi.copyFromContent(url);
    this.copiedUrl = url;

    clearTimeout(this.copyTimer); // cancel any older timer
    this.copyTimer = setTimeout(() => (this.copiedUrl = null), this.COPIED_RESET_MS);
  }

  ngOnDestroy(): void {
    clearTimeout(this.copyTimer);
  }
}